import { useEffect, useState } from "react";
import TabSelection from "./TabSelection";
import { Divider, Typography, Box, Link, useTheme, Card } from "@mui/material"; // Added CircularProgress
import CircleIcon from "@mui/icons-material/Circle";
import { useSelector } from "react-redux";
import Jira_Img from "../../assets/baseVersion/Jira_Img.svg";
import Mitigation from "../../assets/baseVersion/Mitigation.svg";
import Defence_Evasion_Mitre from "../../assets/baseVersion/Defense_Evasion_Mitre.svg";
import Reconnaissance_Mitre from "../../assets/baseVersion/Reconnaissance_Mitre.svg";
import Dicovery_Mitre from "../../assets/baseVersion/Discovery_Mitre.svg";
import Collection_Mitre from "../../assets/baseVersion/Collection_Mitre.svg";
import Persistence_Mitre from "../../assets/baseVersion/Perisistence_Mitre.svg";
import Impact_Mitre from "../../assets/baseVersion/Impact_Mitre.svg";
import Credential_Access_Mitre from "../../assets/baseVersion/Credenitial_Access_Mitre.svg";
import Lateral_Movement_Mitre from "../../assets/baseVersion/Lateral_Movement_Mitre.svg";
import Command_Control_Mitre from "../../assets/baseVersion/Command_Control_Mitre.svg";
import Initial_Access_Mitre from "../../assets/baseVersion/Initial_Access_Mitre.svg";
import Privilege_Escalation_Mitre from "../../assets/baseVersion/Privilege_Escalation_Mitre.svg";
import Resource_Development_Mitre from "../../assets/baseVersion/Resource_Development_Mitre.svg";
import Execution_Mitre from "../../assets/baseVersion/Execution_Mitre.svg";
//import Exfilitration_Mitre from "../../../../assets/baseVersion/Exfilitration_Mitre.svg";
import Exfilitration_Mitre from "../../assets/baseVersion/Execution_Mitre.svg"
import axiosInstance from "../../axios/axios";
import { SkeletonLoader } from "../../modules/dashboard/shared";


interface ComplianceItem {
  control_id: string;
  control_code: string;
  attributes: {
    Family?: string;
    "Sort-As"?: string;
    UPDATED?: string;
    Discussion?: string;
    Discussion2?: string;
    "Security Requirement"?: string;
    "Basic/Derived Security Requirement"?: string;
    Title?: string;
    TITLE?: string;
    Description?: string;
    DESCRIPTION?: string;
    description?: {
      Discussion?: string;
    };
    "Implementation Group 1"?: string;
    "Implementation Group 2"?: string;
    "Implementation Group 3"?: string;
    "Control Name"?: string;
    "Purpose"?: string;
    "Customized Approach Objective"?: string;
    "Approach Testing Procedures"?: string;
    "Section Name"?: string;
    "Requirement Name"?: string;
  };
  references: Record<string, any>;
  version_id: string;
  version_number: string;
  control_type_id: string;
  control_type: string;
  control_display_name: string;
  category: string;
}

const Compliance = ({ id, module }: { id: string, module: string }) => {
  const [complianceData, setComplianceData] = useState<{
    [version: string]: {
      control_type: string;
      items: ComplianceItem[];
    };
  }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [showFullDescription, setShowFullDescription] = useState<
    Map<string, boolean>
  >(new Map());
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const [mitreControlGroups, setMitreControlGroups] = useState<
    {
      tatcic_id: string;
      technique_id: string;
      tactic_control_code: string;
      technique_control_code: string;
      tactic_url: string;
      technique_url: string;
      tattic_name: string;
      technique_name: string;
      description: string;
    }[]
  >([]);

  const [mitreMitigation, setMitreMitigation] = useState<
    {
      mitigation_id: string;
      mitigation_control_code: string;
      mitigation_name: string;
      mitigation_url: string;
      mitigation_description: string;
    }[]
  >([]);

  // let module = "";
  // if (location.pathname.startsWith("/onprem/scan")) {
  //   module = "on_premise";
  // } else {
  //   module = "cloud";
  // }

  const Details_Data = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedButton
  );
  // Category comes from the selected compliance-list tab (Benchmark, Framework, or MITRE).
  const selectedCategory = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedCategory
  );

  console.log("Details_Data:", Details_Data);
  console.log("Module:", module);

  // Reset isReady when dependencies change
  useEffect(() => {
    setIsReady(false);
    setLoading(true);
    setShowFullDescription(new Map());
  }, [id, Details_Data, selectedCategory]);

  // Main data fetching effect
  useEffect(() => {
    const fetchData = async () => {
      if (!id || !Details_Data || !selectedCategory) return;

      setLoading(true);
      setIsReady(false);

      try {
        if (
          Details_Data === "cis" ||
          Details_Data === "nist" ||
          Details_Data === "pci dss" ||
          Details_Data === "spark"
          // || Details_Data === "hippa"
          // || Details_Data === "disa"
        ) {
          const endpoint = "securityscan/controls-by-parameter";
          const response = await axiosInstance.get(endpoint, {
            params: {
              control_type: Details_Data?.toUpperCase(),
              category_name: selectedCategory,
              parameter_name_id: id,
              module: module,
            },
          });

          const rawData = response.data?.data;

          if (rawData && Array.isArray(rawData)) {
            const groupedData: {
              [version: string]: {
                control_type: string;
                items: ComplianceItem[];
              };
            } = {};

            rawData.forEach((item: any) => {
              const version = item.version_number;
              if (!groupedData[version]) {
                groupedData[version] = {
                  control_type: item.control_type,
                  items: [],
                };
              }
              groupedData[version].items.push(item);
            });

            setComplianceData(groupedData);
            if (Object.keys(groupedData).length > 0) {
              setIsReady(true);
            }
          } else {
            console.warn("Expected array data not found:", response.data);
            setComplianceData({});
          }
        } else if (Details_Data === "mitre") {
          const endpoint = `securityscan/parameter-control-groups/${id}`;
          const response = await axiosInstance.get(endpoint);

          const control_groups =
            response.data?.data?.control_groups?.map((item: any) => ({
              tatcic_id: item?.tactic?.id,
              technique_id: item?.technique?.id,
              tactic_control_code: item?.tactic?.control_code,
              technique_control_code: item?.technique?.control_code,
              tactic_url: item?.tactic?.attributes?.url,
              technique_url: item?.technique?.attributes?.url,
              tattic_name: item?.tactic?.attributes?.name,
              technique_name: item?.technique?.attributes?.name,
              description: item?.technique?.attributes?.description,
            })) || [];

          const mitigation = response?.data?.data?.distinct_mitigations.map(
            (item: any) => ({
              mitigation_id: item?.id,
              mitigation_control_code: item?.control_code,
              mitigation_name: item?.attributes?.name,
              mitigation_url: item?.attributes?.url,
              mitigation_description: item?.attributes?.description,
            })
          );

          setMitreMitigation(mitigation);
          setMitreControlGroups(control_groups);
          setIsReady(control_groups.length > 0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (
          Details_Data === "cis" ||
          Details_Data === "nist" ||
          Details_Data === "pci dss" ||
          Details_Data === "spark"
          // || Details_Data === "hippa"
          // || Details_Data === "disa"
        ) {
          setComplianceData({});
        } else {
          setMitreControlGroups([]);
          setMitreMitigation([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, Details_Data, selectedCategory, module]);

  return (
    <div>
      <div style={{padding:3,paddingTop:3}}>
      <TabSelection setLoading={setLoading} module={module}/>
      </div>
      <Divider sx={{ mt: 2, mb: 2 }} />

      {Details_Data === "cis" ||
        Details_Data === "nist" ||
        // Details_Data === "hippa" ||
        Details_Data === "pci dss" ||
        Details_Data === "spark" /* || Details_Data === "disa" */ ? (
        <div style={{ paddingLeft: 15 }}>
          {!isReady || loading ? (
            <Box>
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 45)}
                styles={{ height: 20 }}
              />
            </Box>
          ) : Object.keys(complianceData).length > 0 ? (
            Object.entries(complianceData).map(
              ([version, { control_type, items }]) => (
                <div key={version}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", fontSize: "16px", mb: 2 }}
                  >
                    {control_type} Version {version}
                  </Typography>

                  {items.length > 0 ? (
                    items.map((item) => (
                      <div key={item.control_id} style={{ marginBottom: 10 }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                          >
                            {item.control_code}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                          >
                            {/* Title fallbacks */}
                            {item.attributes?.Title ||
                              item.attributes?.TITLE ||
                              item.attributes?.["Control Name"] ||
                              item.attributes?.["CIS Name"] ||
                              (item.attributes as any)?.name}
                          </Typography>
                        </div>
                        <Typography
                          variant="body2"
                          sx={{ color: "#716DA0", mb: 1 }}
                        >
                          {/* Description fallbacks */}
                          {item.attributes?.Description ||
                            item.attributes?.DESCRIPTION ||
                            (item.attributes as any)?.["CIS Descreption UI"] ||
                            (item.attributes as any)?.["CIS Descreption"] ||
                            item.attributes?.description?.Discussion ||
                            item.attributes?.Discussion ||
                            item.attributes?.Discussion2 ||
                            item.attributes?.["Purpose"] ||
                            item.attributes?.["Section Name"]}
                        </Typography>

                        {/* PCI DSS specific fields */}
                        {Details_Data === "pci dss" && (
                          <>
                            {item.attributes?.["Requirement Name"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 1 }}>
                                Requirement Name: {item.attributes["Requirement Name"]}
                              </Typography>
                            )}
                            {item.attributes?.["Section Name"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 1 }}>
                                Section Name: {item.attributes["Section Name"]}
                              </Typography>
                            )}
                            {item.attributes?.["Approach Testing Procedures"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 1 }}>
                                Testing Procedures: {item.attributes["Approach Testing Procedures"]}
                              </Typography>
                            )}
                            {item.attributes?.["Customized Approach Objective"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 1 }}>
                                Customized Approach Objective: {item.attributes["Customized Approach Objective"]}
                              </Typography>
                            )}
                          </>
                        )}

                        {/* NIST fields */}
                        {Details_Data?.toUpperCase() === "NIST" &&
                          item.attributes?.["Security Requirement"] && (
                            <Typography
                              variant="body2"
                              sx={{ color: "#716DA0", mb: 1 }}
                            >
                              Security Requirement: {" "}
                              {item.attributes["Security Requirement"]}
                            </Typography>
                          )}

                        {/* CIS fields */}
                        {Details_Data?.toUpperCase() === "CIS" && (
                          <>
                            {(item.attributes as any)?.["CIS Section"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 0.5 }}>
                                Section: {(item.attributes as any)["CIS Section"]}
                              </Typography>
                            )}
                            {(item.attributes as any)?.["CIS Level"] && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 0.5 }}>
                                Level: {(item.attributes as any)["CIS Level"]}
                              </Typography>
                            )}
                            {((item.attributes as any)?.["CIS Rationale UI"] || (item.attributes as any)?.["CIS Rationale"]) && (
                              <Typography variant="body2" sx={{ color: "#716DA0", mb: 0.5 }}>
                                Rationale: {(item.attributes as any)["CIS Rationale UI"] || (item.attributes as any)["CIS Rationale"]}
                              </Typography>
                            )}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 10,
                              }}
                            >
                            {item.attributes?.[
                              "Implementation Group 1"
                            ]?.toUpperCase() === "X" && (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  IG1: {" "}
                                  <CircleIcon
                                    sx={{
                                      color: "#6CBD54",
                                      fontSize: 12,
                                    }}
                                  />
                                </Typography>
                              )}

                            {item.attributes?.[
                              "Implementation Group 2"
                            ]?.toUpperCase() === "X" && (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  IG2: {" "}
                                  <CircleIcon
                                    sx={{
                                      color: "#F08B0E",
                                      fontSize: 12,
                                    }}
                                  />
                                </Typography>
                              )}

                            {item.attributes?.[
                              "Implementation Group 3"
                            ]?.toUpperCase() === "X" && (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  IG3: {" "}
                                  <CircleIcon
                                    sx={{
                                      color: "#02AFBD",
                                      fontSize: 12,
                                    }}
                                  />
                                </Typography>
                              )}
                          </div>
                        </>
                        )}

                        <Divider sx={{ mt: 2 }} />
                      </div>
                    ))
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ color: "#716DA0", mb: 1 }}
                    >
                      No data available for version {version}.
                    </Typography>
                  )}
                </div>
              )
            )
          ) : (
            <Typography variant="body2" sx={{ color: "#716DA0", mb: 1 }}>
              No compliance data available.
            </Typography>
          )}
        </div>
      ) : (
        <>
          {!isReady || loading ? (
            <Box>
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 45)}
                styles={{ height: 20 }}
              />
            </Box>
          ) : (
            <>
              <div style={{ padding: 5, paddingLeft: 15 }}>
                {mitreControlGroups.length > 0 ? (
                  mitreControlGroups.map((group) => {
                    let tactic_img;

                    switch (group.tactic_control_code) {
                      case "TA0005":
                        tactic_img = Defence_Evasion_Mitre;
                        break;
                      case "TA0043":
                        tactic_img = Reconnaissance_Mitre;
                        break;
                      case "TA0007":
                        tactic_img = Dicovery_Mitre;
                        break;
                      case "TA0009":
                        tactic_img = Collection_Mitre;
                        break;
                      case "TA0003":
                        tactic_img = Persistence_Mitre;
                        break;
                      case "TA0040":
                        tactic_img = Impact_Mitre;
                        break;
                      case "TA0006":
                        tactic_img = Credential_Access_Mitre;
                        break;
                      case "TA0008":
                        tactic_img = Lateral_Movement_Mitre;
                        break;
                      case "TA0011":
                        tactic_img = Command_Control_Mitre;
                        break;
                      case "TA0001":
                        tactic_img = Initial_Access_Mitre;
                        break;
                      case "TA0004":
                        tactic_img = Privilege_Escalation_Mitre;
                        break;
                      case "":
                        tactic_img = Resource_Development_Mitre;
                        break;
                      case "TA0002":
                        tactic_img = Execution_Mitre;
                        break;
                      case "TA0010":
                        tactic_img = Exfilitration_Mitre;
                        break;
                      default:
                        tactic_img = "/images/default.png";
                    }

                    return (
                      <div
                        key={group.tatcic_id}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <img src={tactic_img} alt="" />
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            {group.tattic_name} ({group?.tactic_control_code})
                          </Typography>
                          <Link
                            href={group?.tactic_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={Jira_Img}
                              alt=""
                              style={{ marginLeft: 3, cursor: "pointer" }}
                            />
                          </Link>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            {group.technique_name} (
                            {group?.technique_control_code})
                          </Typography>
                          <Link
                            href={group?.technique_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={Jira_Img}
                              alt=""
                              style={{ marginLeft: 3, cursor: "pointer" }}
                            />
                          </Link>
                        </div>

                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold", fontSize: "16px" }}
                        >
                          Description
                        </Typography>

                        <div
                          key={group?.technique_id}
                          style={{ marginBottom: 15 }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#716DA0",
                              fontWeight: 400,
                              fontSize: "14px",
                              mb: 1,
                              whiteSpace: "pre-line",
                              display: "inline",
                            }}
                          >
                            {group?.description?.length > 300 &&
                              !showFullDescription.get(group.technique_id)
                              ? `${group.description.substring(0, 300)}... `
                              : group?.description ||
                              "No description available"}
                            {group?.description?.length > 300 && (
                              <Typography
                                component="span"
                                color="primary"
                                sx={{
                                  cursor: "pointer",
                                  color: isDarkMode ? "#FFFFFF" : "#3A2ADA",
                                  display: "inline",
                                }}
                                onClick={() => {
                                  const newMap = new Map(showFullDescription);
                                  newMap.set(
                                    group.technique_id,
                                    !showFullDescription.get(group.technique_id)
                                  );
                                  setShowFullDescription(newMap);
                                }}
                              >
                                {showFullDescription.get(group.technique_id)
                                  ? "Show less"
                                  : "Show more"}
                              </Typography>
                            )}
                          </Typography>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <Typography>No {module} control groups available.</Typography>
                )}
              </div>

              <Divider sx={{ mb: 3 }} />
              <Card
                variant="outlined"
                sx={{ backgroundColor: isDarkMode ? "#191C24" : "#F8F8FF" }}
              >
                {mitreMitigation.length > 0
                  ? mitreMitigation?.map((data: any) => (
                    <div key={data.mitigation_id} style={{ padding: 15 }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 10,
                          alignItems: "center",
                          marginBottom: 10,
                        }}
                      >
                        <img src={Mitigation} alt="" />
                        <Typography>Mitigation</Typography>

                        <Link
                          key={data.mitigation_id}
                          href={data?.mitigation_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={Jira_Img}
                            alt=""
                            style={{ marginLeft: 3, cursor: "pointer" }}
                          />
                        </Link>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 150,
                          marginBottom: 10,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold" }}
                        >
                          ID
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Name
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 115,
                          marginBottom: 10,
                        }}
                      >
                        <Typography>
                          {data?.mitigation_control_code}
                        </Typography>
                        <Typography>{data?.mitigation_name}</Typography>
                      </div>
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        Description
                      </Typography>
                      <Typography variant="body2">
                        {data?.mitigation_description}
                      </Typography>
                    </div>
                  ))
                  : null}
              </Card>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Compliance;
